<template>
  <dashboard-layout>
    <router-view :key="$route.path" />
  </dashboard-layout>
</template>

<script>
import DashboardLayout from '@/layouts/dashboard.vue';
export default {
  components: {
    DashboardLayout
  }
}
</script>